<script lang="ts">
	import type { SbSeoMetadata } from '../types';
	import { page } from '$app/state';
	import type { ISbStoryData } from '@storyblok/js';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			seo?: SbSeoMetadata;
			automatic_coupon_code?: string;
			header: ISbStoryData['content'][];
			body: ISbStoryData['content'][];
			footer: ISbStoryData['content'][];
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<svelte:head>
	<title>{content.seo?.title || 'Mill: never waste food again'}</title>
	<meta name="description" content={content.seo?.description} />
	<meta
		property="og:title"
		content={content.seo?.og_title || content.seo?.title || page.data.og_metadata.title}
	/>
	<meta
		property="og:description"
		content={content.seo?.og_description ||
			content.seo?.description ||
			page.data.og_metadata.description}
	/>
	<meta property="og:type" content="website" />
	<meta property="og:url" content={page.data.og_metadata.url} />
	<meta property="og:image" content={content.seo?.og_image || page.data.og_metadata.image} />
	<meta
		property="og:image:secure_url"
		content={content.seo?.og_image || page.data.og_metadata.image}
	/>
</svelte:head>

<section class="min-h-svh bg-white">
	{#if content.header?.length > 0}
		<Blok content={content.header[0]} />
	{/if}

	<div class="flex flex-col justify-between">
		<div class="mt-14 lg:mt-25">
			{#each content.body || [] as body}
				<Blok content={body} />
			{/each}
		</div>

		{#if content.footer?.length > 0}
			<Blok content={content.footer[0]} />
		{/if}
	</div>
</section>
